import React, { useState, useCallback, useEffect, useRef } from "react";
import { LiquityStoreState, Decimal } from "@liquity/lib-base";
import { useLiquitySelector } from "@liquity/lib-react";
import { FarmViewContext2 } from "./FarmViewContext";
import { transitions } from "./transitions";
import type { FarmView, FarmEvent } from "./transitions";

const transition = (view: FarmView, event: FarmEvent): FarmView => {
  const nextView = transitions[view][event] ?? view;
  return nextView;
};

const getInitialView = (
  liquidityMiningStake2: Decimal,
  remainingLiquidityMiningLQTYReward2: Decimal,
  liquidityMiningLQTYReward2: Decimal
): FarmView => {
  if (remainingLiquidityMiningLQTYReward2.isZero) return "DISABLED";
  if (liquidityMiningStake2.isZero && liquidityMiningLQTYReward2.isZero) return "INACTIVE";
  return "ACTIVE";
};

const selector = ({
  liquidityMiningStake2,
  remainingLiquidityMiningLQTYReward2,
  liquidityMiningLQTYReward2
}: LiquityStoreState) => ({
  liquidityMiningStake2,
  remainingLiquidityMiningLQTYReward2,
  liquidityMiningLQTYReward2
});

export const FarmViewProvider2: React.FC = props => {
  const { children } = props;
  const {
    liquidityMiningStake2,
    remainingLiquidityMiningLQTYReward2,
    liquidityMiningLQTYReward2
  } = useLiquitySelector(selector);

  const [view, setView] = useState<FarmView>(
    getInitialView(
      liquidityMiningStake2,
      remainingLiquidityMiningLQTYReward2,
      liquidityMiningLQTYReward2
    )
  );
  const viewRef = useRef<FarmView>(view);

  const dispatchEvent = useCallback((event: FarmEvent) => {
    const nextView = transition(viewRef.current, event);

    //Shinto
    // console.log(
    //   "dispatchEvent() [current-view, event, next-view]",
    //   viewRef.current,
    //   event,
    //   nextView
    // );
    setView(nextView);
  }, []);

  useEffect(() => {
    viewRef.current = view;
  }, [view]);

  useEffect(() => {
    if (liquidityMiningStake2.isZero && liquidityMiningLQTYReward2.isZero) {
      dispatchEvent("UNSTAKE_AND_CLAIM_CONFIRMED2");
    } else if (liquidityMiningStake2.isZero && !liquidityMiningLQTYReward2.isZero) {
      dispatchEvent("UNSTAKE_CONFIRMED2");
    }
  }, [liquidityMiningStake2.isZero, liquidityMiningLQTYReward2.isZero, dispatchEvent]);

  const provider = {
    view,
    dispatchEvent
  };

  return <FarmViewContext2.Provider value={provider}>{children}</FarmViewContext2.Provider>;
};